// extracted by mini-css-extract-plugin
export default {"slideContent":"slider-content_slideContent__19oYn","slideImg":"slider-content_slideImg__rZf+l","slideDescription":"slider-content_slideDescription__p38OL"};